<template>
    <v-container fluid fill-height full-width class="pa-0">
        <v-card class="black--text" color="white" width="100%">
            <v-toolbar color="amber" height="40">
                <v-btn icon @click="close()"> <v-icon>mdi-close</v-icon></v-btn>
                <v-toolbar-title class="font-weight-bold body-2 text-uppercase black--text">{{orderDetail.productName}} > {{conditionType}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-chip label color="black" text-color="amber" small v-if="orderDetail.productNature != ''" class="caption font-weight-bold text-uppercase"> 
                        {{orderDetail.productNature}}
                    </v-chip>
            </v-toolbar>
            <!--<v-row class="mt-10 mx-0" >
                <v-col cols=12 md=4 sm=6>
                        <v-card class="cardShadow">
                            <div class="pa-2">
                                <p class="font-weight-light subtitle-1 ma-0">Demand rate: {{dRate}} /-</p>
                                <p class="font-weight-light subtitle-1 ma-0">Order type: {{orderType}}</p>
                                <p class="font-weight-light subtitle-1 ma-0">CreditDay: {{paymentCond}}</p>
                                <p class="font-weight-light subtitle-1 ma-0" v-if="orderType =='FOR'">Location: {{location}}</p>
                            </div>
                        </v-card>
                </v-col>
            </v-row>-->
            <v-card-text>
                <v-row class="mx-0">
                    <v-col cols=12 md=6 sm=6 lg=6>
                        <v-text-field v-model="oQty" outlined color="amber" label="Qty / Tons" dense hide-details></v-text-field>
                    </v-col>
                    <v-col cols=12 md=6 sm=6 lg=6>
                        <v-text-field v-model="oRate" outlined color="amber" label="Rate / Qtl" dense hide-details></v-text-field>
                    </v-col>
                </v-row>
                <v-row class="mx-0">
                    <v-col cols=12 md=6 sm=6 lg=6>
                        <v-menu ref="oPaymentDateMenu" v-model="oPaymentDateMenu" :close-on-content-click="true" transition="scale-transition" offset-y min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="oPaymentDate" label="Payment Date"  outlined prepend-inner-icon="mdi-calendar-range" color="amber"
                                readonly v-on="on"></v-text-field>
                            </template>
                            <v-date-picker color="amber" v-model="oPaymentDate" scrollable :min="new Date().toISOString().substr(0, 10)"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols=12 md=6 sm=6 lg=6>
                        <v-text-field v-model="paymentCond" disabled readonly outlined color="amber" label="Payment Credit Days" hide-details></v-text-field>
                    </v-col>
                </v-row>
                <v-col cols=12 md=12 lg=12 sm=12 class="text-right">
                    <v-btn  color="amber" class="black--text" :loading="loading" @click="Save()">Save</v-btn>
                </v-col>
            </v-card-text>
        </v-card>
        <span style="display:none;">{{checkAndFetch}}{{checkandfetch}}</span>
    </v-container>
  
</template>

<script>
import { SERVER_API } from '../../API'
    export default {
        created(){
            window.addEventListener('keyup', event => {
                if(event.which === 27){
                    this.close();
                }
                if(event.which === 13){
                    this.Save();
                }
            })
        },
        data(){
            return{
                loading:false,
                locationRecord:[],
                location:'',
                orderDetail:[],
                orderType:'',
                dRate:'',
                conditionType: '',
                oQty:'',
                oRate:'',
                oPaymentDate:'',
                paymentCond:'',
                oPaymentDateMenu:false,
                oLoadingDateMenu:false,
                locationData:'',
            }
        },
        props:{
            updateid: {
                type: Number,
                required: true,
            },
            edit: {
                type: Boolean,
            },
            cond: {
                type: String,
                required: true,
            },
            OrdType: {
                type: String,
                required: true,
            },
            LocationId: {
                type: Number,
                required: true,
            },
        },
        computed:{
            checkAndFetch(){
               return this.fetchedbyid();
            },
            checkandfetch(){
                return this.fetchLocationbyId();
            }
        },
        methods:{
            async fetchLocationbyId(){
                if(this.orderType == "FOR"){
                    const response = await this.$http.get(SERVER_API+'/location/byid/'+this.LocationId);
                    this.locationData = response.data.data;
                    this.location = response.data.data.location;
                }
            },
            reset() {
                this.oQty = '';
                this.oRate = '';
                //this.conditionType = '';
                this.oPaymentDate = '';
                //this.oLoadingDate = '';
            },
            close(){
                this.reset();
                this.$emit('close',false);
            },
            async fetchedbyid(){
                this.conditionType = this.cond;
                this.orderType = this.OrdType;
                    var Response;
                if(this.OrdType == 'FOR'){
                    Response = await this.$http.get(SERVER_API+'/dailyupdate/byid/'+this.LocationId+'/'+this.updateid);
                }else{
                     Response = await this.$http.get(SERVER_API+'/dailyupdate/byid/'+this.updateid);
                }
                this.orderDetail = Response.data.data;
                if(this.cond == 'ready' && this.OrdType == 'EX'){
                    this.dRate = this.orderDetail.readyRate;
                    this.paymentCond = 'Advance';
                }
                if(this.cond == 'forward' && this.OrdType == 'EX'){
                    this.dRate = this.orderDetail.forwardRate;
                    this.paymentCond = 'Advance';
                }
                if(this.cond == 'ready' && this.OrdType == 'FOR'){
                    this.dRate = this.orderDetail.forReadyRate;
                    this.paymentCond = this.orderDetail.forReadyCday;
                }
                if(this.cond == 'forward' && this.OrdType == 'FOR'){
                    this.dRate = this.orderDetail.forForwardRate;
                    this.paymentCond = this.orderDetail.forForwardCday;
                }
                
            },
            async Save(){
                try{
                    this.loading = true;
                    const Response = await this.$http.post(SERVER_API+'/order/create',{
                        updateId:this.updateid,
                        dRate:this.dRate,
                        product: this.orderDetail.productId,
                        orderType: this.orderType,
                        conditionType: this.conditionType,
                        // Above Fixed
                        location: this.location,
                        oQty: this.oQty,
                        oRate: this.oRate,
                        paymentCond: this.paymentCond,
                        oPaymentDate: this.oPaymentDate,
                    });
                    this.loading = false;
                    this.reset();
                    this.$emit('Response', Response.data);
                }catch(error){
                    this.loading = false;
                    this.$emit('Response', error);
                }
            }
        }
    }
</script>
<style scoped>
.fixedBar{
    z-index: 99;
    height: 64px;
    position: fixed;
    width: 100%;
}
.mt-10{
    margin-top:80px !important;
}
</style>